var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram 1",
    clipPath: "url(#clip0_295_29007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "url(#paint0_linear_295_29007)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.8238 8H14.1838C10.7758 8 8.00781 10.768 8.00781 14.176V21.816C8.00781 25.224 10.7758 27.992 14.1838 27.992H21.8238C25.2318 27.992 27.9998 25.224 27.9998 21.816V14.176C27.9998 10.768 25.2318 8 21.8238 8ZM25.7678 21.824C25.7678 24 23.9998 25.776 21.8158 25.776H14.1758C11.9998 25.776 10.2238 24.008 10.2238 21.824V14.184C10.2238 12.008 11.9918 10.232 14.1758 10.232H21.8158C23.9918 10.232 25.7678 12 25.7678 14.184V21.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9997 12.8877C15.1837 12.8877 12.8877 15.1837 12.8877 17.9997C12.8877 20.8157 15.1837 23.1117 17.9997 23.1117C20.8157 23.1117 23.1117 20.8157 23.1117 17.9997C23.1117 15.1837 20.8157 12.8877 17.9997 12.8877ZM17.9997 21.1037C16.2877 21.1037 14.8957 19.7117 14.8957 17.9997C14.8957 16.2877 16.2877 14.8957 17.9997 14.8957C19.7117 14.8957 21.1037 16.2877 21.1037 17.9997C21.1037 19.7117 19.7117 21.1037 17.9997 21.1037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.5003 13.4482C23.9713 13.3718 24.2912 12.9281 24.2149 12.4571C24.1385 11.9862 23.6948 11.6663 23.2239 11.7426C22.7529 11.819 22.433 12.2627 22.5093 12.7336C22.5857 13.2046 23.0294 13.5245 23.5003 13.4482Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_29007",
    x1: 4.29432,
    y1: 31.7057,
    x2: 29.8743,
    y2: 6.12568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_29007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramImg);
export default __webpack_public_path__ + "static/media/instagram-img.046ed0aa7d2c8ba08c58e6d1dae4f904.svg";
export { ForwardRef as ReactComponent };